import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { useFocusedField } from "../../../../contexts/focused-field-provider.js";
import { useScroll } from "../../../../contexts/scroll-provider.js";
const Focusable = ({ children, fieldId }) => {
  const viewRef = useRef(null);
  const { scrollTo } = useScroll();
  const { focusedFieldId } = useFocusedField();
  useEffect(() => {
    if (viewRef.current && fieldId === focusedFieldId) {
      scrollTo(viewRef.current);
    }
  }, [scrollTo, fieldId, focusedFieldId]);
  return /* @__PURE__ */ jsx("div", { ref: viewRef, children });
};
export {
  Focusable
};
//# sourceMappingURL=focusable.js.map
